import { Activity } from './Activity';
import { RewardWallet } from './RewardWallet';

export class TransactionsHistory {
    earliestPointsToExpireDate: string;
    maximumPointsLimit: number;
    pointsCount: number;
    pointsRewardAmount: number;
    pointsTrackerDescription: string;
    pointsUntilReward: number;
    rewardsWallets: Array<RewardWallet>;
    timeLine: Array<Activity>;
    totalRewardAmount: number;

    public static Make(obj: any): TransactionsHistory {
        const transactionsHistory = new TransactionsHistory();
        Object.assign(transactionsHistory, obj);
        return transactionsHistory;
    }
}
